module.exports = __webpack_public_path__ + "media/images/logo_daiwaestate-864be0818dad88c4c63681a59452a2d3.png";